import { render, staticRenderFns } from "./reviewAccessDenied.vue?vue&type=template&id=508f8f90&scoped=true&"
import script from "./reviewAccessDenied.vue?vue&type=script&lang=js&"
export * from "./reviewAccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./reviewAccessDenied.vue?vue&type=style&index=0&id=508f8f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f8f90",
  null
  
)

export default component.exports